import M$plugin$GetFeatInf from 'C:/proyectos/getfeatinf/src/facade/js/getfeatinf';
import M$control$GetFeatInfControl from 'C:/proyectos/getfeatinf/src/facade/js/getfeatinfcontrol';
import M$impl$control$GetFeatInfControl from 'C:/proyectos/getfeatinf/src/impl/ol/js/getfeatinfcontrol';

if (!window.M.plugin) window.M.plugin = {};
if (!window.M.control) window.M.control = {};
if (!window.M.impl) window.M.impl = {};
if (!window.M.impl.control) window.M.impl.control = {};
window.M.plugin.GetFeatInf = M$plugin$GetFeatInf;
window.M.control.GetFeatInfControl = M$control$GetFeatInfControl;
window.M.impl.control.GetFeatInfControl = M$impl$control$GetFeatInfControl;
